// ─── Toast ────────────────────────────────────────────────────────────────────

export function toast(
  message: string,
  type: 'default' | 'error' | 'success' = 'default',
  durationMs = 3000
): void {
  const container = document.getElementById('toast-container')!;
  const el = document.createElement('div');
  el.className = `toast toast--${type}`;
  el.textContent = message;
  container.appendChild(el);
  setTimeout(() => el.remove(), durationMs);
}

// ─── Status bar flash ────────────────────────────────────────────────────────

export function showStatusBar(bar: HTMLElement): void {
  bar.style.transform = 'scaleX(1)';
  setTimeout(() => { bar.style.transform = 'scaleX(0)'; }, 800);
}

// ─── Score delta pop ─────────────────────────────────────────────────────────

export function spawnScoreDelta(delta: number, anchor: HTMLElement): void {
  const el = document.createElement('div');
  el.className = 'score-delta';
  el.textContent = `+${delta}`;

  const rect = anchor.getBoundingClientRect();
  el.style.left = `${rect.left + rect.width / 2}px`;
  el.style.top  = `${rect.top}px`;

  document.body.appendChild(el);
  setTimeout(() => el.remove(), 2000);
}

// ─── Player list renderer ────────────────────────────────────────────────────

import type { Player } from '../../shared/types';

export function renderPlayerChip(player: Player): HTMLElement {
  const chip = document.createElement('div');
  chip.className = `player-chip${player.status === 'ghost' ? ' player-chip--ghost' : ''}`;
  chip.dataset.playerId = player.id;

  const icon = player.status === 'ghost'   ? '💀'
             : player.status === 'rescued' ? '🪙'
             : player.isHost               ? '👑'
             : '🟠';

  chip.innerHTML = `
    <span class="player-chip__icon">${icon}</span>
    <span class="player-chip__name">${escHtml(player.username)}</span>
    ${player.vote ? `<span class="player-chip__status">${player.vote === 'ready' ? '👍' : '👎'}</span>` : ''}
  `;
  return chip;
}

// ─── Countdown button ────────────────────────────────────────────────────────

export function startCountdown(
  btn: HTMLButtonElement,
  seconds: number,
  label: string
): void {
  btn.disabled = true;
  let remaining = seconds;

  const tick = () => {
    btn.textContent = `${label} (${remaining})`;
    if (remaining <= 0) {
      btn.disabled = false;
      btn.textContent = label;
      return;
    }
    remaining--;
    setTimeout(tick, 1000);
  };
  tick();
}

// ─── Escape HTML ─────────────────────────────────────────────────────────────

export function escHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// ─── Format score ─────────────────────────────────────────────────────────────

export function fmtScore(n: number): string {
  return n.toLocaleString();
}
